import React, { useState, useEffect } from 'react'
import ResponseMsg from '../general/ResponseMsg';
import StaffImg from '../assets/staff-img.png';
import StaffImg1 from '../assets/staff-img1.gif';
import Loading from '../general/Loading';

const AddDeliveryAgent = () => {
  const [response, setResponse] = useState(null);
  const [staff, setStaff] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState('');
  const [showDelete, setShowDelete] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
     const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [newStaff, setNewStaff] = useState({
    name: '',
    phone: '',
    password: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
  });

  // Fetch staff members on component mount
  useEffect(() => {
    const fetchStaff = async () => {
      setLoading(true);
      try {
        const response = await fetch('https://api.kcmstore.in/store/get-delivery-agent');

        setLoading(false);
        if (response.ok) {
          const data = await response.json();
  const sortedData = data.sort((a, b) => b.id - a.id);
          setStaff(sortedData);
        } else {
          setLoading(false);
          console.error('Failed to fetch Delivery Agent');
        }
      } catch (error) {
        setLoading(false);
        console.error('Error fetching Delivery Agent:', error);
      }
    };

    fetchStaff();
  }, []);


  const handleRemoveDialog = (staffMem) => {
    setSelectedStaff(staffMem);
    setShowDelete(true);
  }

  const handleRemove = async (staffId) => {
    setLoading(true);

    try {
      const response = await fetch(`https://api.kcmstore.in/store/delete-delivery-agent/${staffId}`, {
        method: 'DELETE',
      });

      setLoading(false);
      if (response.ok) {
        setStaff((prevStaff) => prevStaff.filter((staff) => staff.id !== staffId));
        setResponse('Delivery Agent Removed successfully!');
        setTimeout(() => {
          setResponse('');
        }, 2000);
        setShowDelete(false);
      } else {
        setLoading(false);
        setResponse('Unable to Delete Delivery Agent.');
        setTimeout(() => {
          setResponse('');
        }, 2000);
      }
    } catch (error) {
      setLoading(false);
      console.error('Error deleting Delivery Agent:', error);
    }
  };


  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setNewStaff((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Handle Add Staff form submission
  const handleAddStaff = async (e) => {
    e.preventDefault();
    setLoading(true);


    try {
      const response = await fetch('https://api.kcmstore.in/store/add-delivery-agent', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newStaff),
      });

      setLoading(false);

      if (response.ok) {
        setResponse('Delivery Agent added successfully!');
        setTimeout(() => {
          setResponse('');
          setNewStaff({ name: '', phone: '', category: '', password: '' });
          setShowAdd(false);
          window.location.reload();
        }, 2000);
      } else if (response.status == 400) {
        setLoading(false);
        setResponse('Agent exists with same Mobile no.');
        setTimeout(() => setResponse(''), 2000);
      }
      else {
        setLoading(false);
        setResponse('Unable to add Delivery Agent');
        setTimeout(() => setResponse(''), 2000);
      }
    } catch (error) {
      console.error('Error adding Delivery Agent', error);
    }
  };

  const filteredStaff = staff.filter(myStaff =>
    (myStaff.name?.toLowerCase().includes(searchQuery.toLowerCase()) || '') ||
    (myStaff.phone?.toLowerCase().includes(searchQuery.toLowerCase()) || '') ||
    (myStaff.address?.toLowerCase().includes(searchQuery.toLowerCase()) || '') ||
    (myStaff.city?.toLowerCase().includes(searchQuery.toLowerCase()) || '') ||
    (myStaff.state?.toLowerCase().includes(searchQuery.toLowerCase()) || '') ||
    (myStaff.pincode?.toLowerCase().includes(searchQuery.toLowerCase()) || '')
  );
  

  const indianStates = [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", 
    "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", 
    "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", 
    "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", 
    "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal", "Andaman and Nicobar Islands", 
    "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu", "Lakshadweep", 
    "Delhi", "Puducherry"
];


  return (
    <>
      <section className='py-4 bg-light'>
        <div className='px-4'>
          <div className='d-flex'>
            <p className='sec-heading'>Delivery Agent</p>
            <span className='sec-text animate__animated animate__flash animate__slow animate__infinite'>Add</span>
          </div>

          <div className='row justify-content-between'>
            <div className='d-flex bg-white rounded-4 col-lg-10 col-md-8 col-sm-7 col-12 my-2'>
              <i class="fa-solid fa-magnifying-glass text-darkblue pt-3 px-3"></i>
              <input
                type="text"
                className="form-input rounded-4 border-0"
                placeholder="Search Agent"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
            <div className='col-lg-2 col-md-4 col-sm-5 col-12 my-2 order-lg-last order-md-last order-sm-last order-first'>
              <button className='login-btn2' onClick={() => setShowAdd(true)}>Add Agent</button></div>

          </div>


          <div className='row bg-white rounded-4 px-lg-2 py-3 mt-3'>

            {filteredStaff.length > 0 ? (
              filteredStaff.map((staffMem) => (
                <div key={staffMem.id} className='col-lg-4 col-md-6 col-sm-6 col-12 my-2 px-2'>
                  <div className='staff-area d-lg-block d-md-block d-sm-block d-flex '>
                    <img src={StaffImg} className='staff-img' alt='Staff' />
                    <div className='text-lg-center text-md-center text-sm-center text-start'>
                      <p className='featured-category text-capitalize'>Agent Name: {staffMem.name}<br />
                        Phone: {staffMem.phone}<br />Email: {staffMem.email || 'NA'}<br />Address: {staffMem.address || 'NA'}</p>
                      <button className='login-btn mt-4' onClick={() => handleRemoveDialog(staffMem)}>Remove</button></div>
                  </div>
                </div>
              ))
            ) : (
              <>
                <div className='text-center'>
                  <img src={StaffImg1} className='img-fluid col-lg-4 col-md-6 col-sm-6 col-10' alt='Staff' />
                  <p className='fw-bold'>No Delivery Agent Added yet.</p>
                </div>
              </>
            )}


          </div>
          {/* row ends */}

        </div>
      </section>

      {showDelete && (
        <>
          <section className='delete-dialog px-3' onClick={() => setShowDelete(false)}>
            <div className='bg-white col-lg-4 col-md-8 mx-auto px-3 py-3 rounded-4' onClick={(e) => e.stopPropagation()}>
              <p className='featured-category my-4'>Do you want to remove {selectedStaff.name} from Delivery Agent?</p>
              <button className='success-btn' onClick={() => handleRemove(selectedStaff.id)}>Yes</button>&nbsp;&nbsp;
              <button className='danger-btn' onClick={() => setShowDelete(false)}>No</button>
            </div>
          </section>
        </>
      )}


      {showAdd && (
        <>
          <section className='delete-dialog px-3 py-5' onClick={() => setShowAdd(false)}>
            <div className='bg-white col-lg-5 col-md-8 mx-auto px-3 py-3 rounded-4' onClick={(e) => e.stopPropagation()}>

              <p className='sec-heading'>Add Delivery Agent</p>


              <form class="row g-3 text-start" onSubmit={handleAddStaff}>
                <div class="col-12">
                  <label for="inputName" class="form-label fw-semibold">Name</label>
                  <input type="text" class="form-input" id="inputName" name='name' value={newStaff.name} onChange={handleInputChange} required />
                </div>

                <div class="col-md-6">
                  <label for="inputPhone" class="form-label fw-semibold">Phone</label>
                  <input type="tel" maxLength={10} minLength={10} class="form-input" id="inputPhone" name='phone' value={newStaff.phone} onChange={handleInputChange} required />
                </div>

                <div class="col-md-6">
                  <label for="inputPassword4" class="form-label fw-semibold">Password</label>
                  <input type="password" class="form-input" minLength={6} id="inputPassword4" name='password' value={newStaff.password} onChange={handleInputChange} required />
                </div>

                <div class="col-12">
                  <label for="inputAddress" class="form-label fw-semibold">Address</label>
                  <input type="text" class="form-input" id="inputAddress" name='address' value={newStaff.address} onChange={handleInputChange} />
                </div>


                <div class="col-md-4">
                  <label for="inputCity" class="form-label fw-semibold">City</label>
                  <input type="text" class="form-input" id="inputCity" name='city' value={newStaff.city} onChange={handleInputChange} />
                </div>

                <div class="col-md-4">
                  <label for="inputState" class="form-label fw-semibold">State</label>
    <select
        id="state"
        className="form-input"
        name='state'
        value={newStaff.state}
        onChange={handleInputChange}
    >
 <option value="" disabled>Select State</option>
        {indianStates.map((state, index) => (
            <option key={index} value={state}>
                {state}
            </option>
        ))}
    </select>                </div>

                <div class="col-md-4">
                  <label for="inputPincode" class="form-label fw-semibold">Pincode</label>
                  <input type="text" class="form-input" id="inputPincode" name='pincode' value={newStaff.pincode} onChange={handleInputChange} />
                </div>


                <div class="col-12 my-3">
                  <button className='danger-btn' onClick={() => setShowAdd(false)}>Cancel</button>&nbsp;&nbsp;
                  <button type="submit" class="success-btn">Add</button>
                </div>
              </form>

            </div>
          </section>
        </>
      )}

      {response && <ResponseMsg message={response} />}
      {loading && <Loading setLoading={setLoading} />}

    </>
  )
}

export default AddDeliveryAgent
